<template>
	<div class="acu-point-item">
		<v-list-item v-if="grid" style="border: 1px solid #e0e0e0; border-radius: 5px; min-height: 0px" class="pl-2 pr-0 py-0">
			<v-list-item-icon class="mr-2 my-2" style="min-width: 0px">
				<template v-if="point.technics.length == 0">
					<v-icon small color="primary">$vuetify.icons.acuIcon</v-icon>
				</template>
				<template v-else>
					<template v-for="tecId in point.technics">
						<v-icon small color="primary" :key="tecId">
							{{getTechnicIcon(tecId)}}
						</v-icon>
					</template>
				</template>
			</v-list-item-icon>
			<v-list-item-content class="pa-0">
				<v-list-item-title @click="showInfo" class="text-caption font-weight-bold" style="cursor: pointer">
					{{name}} <span v-if="graphic" class="font-weight-light">({{sideLetter}})</span>
				</v-list-item-title>
				<v-list-item-subtitle v-if="!grid">
					{{getSide(point)}}<br/>
					<span v-for="technic in point.technics" :key="technic.id" class="mr-1">-{{technic.name}}</span>
				</v-list-item-subtitle>
			</v-list-item-content>
			<v-list-item-action class="ma-0 ml-2">
				<v-btn v-if="edit" color="primary" icon x-small @click="removePoint(point)" :loading="deleting">
					<v-icon color="primary">delete</v-icon>
				</v-btn>
			</v-list-item-action>
		</v-list-item>
		<v-list-item dense v-else style="border: 1px solid #e0e0e0; border-radius: 5px;">
			<v-list-item-icon class="ma-3 ml-0">
				<template v-if="point.technics.length == 0">
					<v-icon small color="primary">$vuetify.icons.acuIcon</v-icon>
				</template>
				<template v-else>
					<template v-for="tecId in point.technics">
						<v-icon small color="primary" :key="tecId">
							{{getTechnicIcon(tecId)}}
						</v-icon>
					</template>
				</template>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title class="font-weight-bold">
					{{name}}
					<v-tooltip top>
						<template v-slot:activator="{ on }">
							<v-btn icon small @click="showInfo" v-on="on" class="ml-1">
								<v-icon color="primary">info_outline</v-icon>
							</v-btn>
						</template>
						<span v-translate>Point Info</span>
					</v-tooltip>
				</v-list-item-title>
				<v-list-item-subtitle>
					{{side}}
				</v-list-item-subtitle>
			</v-list-item-content>
			<v-list-item-action>
				<v-btn v-if="!settings" icon @click="removePoint" :loading="deleting">
					<v-icon color="primary">delete</v-icon>
				</v-btn>
				<v-btn v-else icon :to="{name: 'edit-acu-point', params: { pid: point.id }}">
					<v-icon color="primary">mdi-pencil</v-icon>
				</v-btn>
			</v-list-item-action>
		</v-list-item>
		<v-dialog v-model="showPointInfo" max-width="360px">
			<v-card>
				<v-card-title class="text-subtitle-2 primary--text mb-3 secondary">
					<v-icon small color="primary" class="mr-1">$vuetify.icons.acuIcon</v-icon>
					<translate>Point</translate>
				</v-card-title>
				<v-card-text v-if="!loading" class="text-caption">
					<p><translate>Name</translate> <span class="font-weight-light">{{name}}</span></p>
					<p><translate>Laterality</translate> <span class="font-weight-light">{{side}}</span></p>
					<!-- <p class="mb-1" v-translate>Description</p>
					<span class="font-weight-light">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book</span> -->
					<p class="mt-2 mb-1" v-translate>Groups</p>
					<p v-if="point.groups.length == 0" class="font-weight-thin ml-2" v-translate>No groups.</p>
					<v-chip v-else class="font-weight-light mr-1 mb-1" small v-for="g in point.groups" :key="'group' + g.id">{{g.name}}</v-chip>
					<template v-if="grid">
						<p class="mb-1" style="cursor: pointer" @click="showEditTechnics = !showEditTechnics">
							<translate>Technics</translate>
							<v-icon color="primary" small>mdi-chevron-down</v-icon>
						</p>
						<v-row no-gutters class="my-2" v-if="showEditTechnics">
							<v-btn-toggle
								v-model="point.technics"
								color="primary"
								multiple
								@change="canSaveTechnics = true"
							>
								<v-btn x-small v-for="technic in technics" :key="technic.id" :value="technic.id">
									<v-icon color="primary" x-small>{{technic.icon}}</v-icon>
								</v-btn>
							</v-btn-toggle>
						</v-row>
						<p v-if="point.technics.length == 0" class="font-weight-thin ml-2" v-translate>No Technics.</p>
						<v-chip v-else class="font-weight-light mr-1 mb-1" small v-for="t in point.technics" :key="'technic' + t">{{getTechnicName(t)}}</v-chip>
					</template>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn v-if="canSaveTechnics" small color="primary" outlined depressed text @click="saveTechnics" :loading="savingEditTechnics">
						<translate>Save</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn small color="primary darken-1" text @click="showPointInfo = false">
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: "AcuPointItem",
	props: ["point", "grid", "settings", "edit", "graphic"],
	data: () => ({
		showPointInfo: false,
		loading: true,
		deleting: false,
		showEditTechnics: false,
		savingEditTechnics: false,
		canSaveTechnics: false
	}),
	computed: {
		name() {
			let strs = this.point.name.split("-");
			let channel = strs[0];
			if(channel == 'LU') return this.$gettext('LU') + "-" + strs[1];
			if(channel == 'PC') return this.$gettext('PC') + "-" + strs[1];
			if(channel == 'HE') return this.$gettext('HE') + "-" + strs[1];
			if(channel == 'SI') return this.$gettext('SI') + "-" + strs[1];
			if(channel == 'SJ') return this.$gettext('SJ') + "-" + strs[1];
			if(channel == 'LI') return this.$gettext('LI') + "-" + strs[1];
			if(channel == 'SP') return this.$gettext('SP') + "-" + strs[1];
			if(channel == 'LIV') return this.$gettext('LIV') + "-" + strs[1];
			if(channel == 'KD') return this.$gettext('KD') + "-" + strs[1];
			if(channel == 'BL') return this.$gettext('BL') + "-" + strs[1];
			if(channel == 'GB') return this.$gettext('GB') + "-" + strs[1];
			if(channel == 'ST') return this.$gettext('ST') + "-" + strs[1];
			if(channel == 'REN') return this.$gettext('REN') + "-" + strs[1];
			if(channel == 'DU') return this.$gettext('DU') + "-" + strs[1];
			if(channel == 'EX') return this.$gettext('EX') + "-" + strs[1];
			if(channel == 'ASHI') return "ASHI" + "-" + strs[1];
			return this.point.name;
		},
		side() {
			if (this.point.side === "left") return this.$gettext("Left");
			else if (this.point.side === "right") return this.$gettext("Right");
			else return this.$gettext("Center");
		},
		technics() {
			let technics = [
        {id: 1, name: this.$gettext("Acupuncture"), icon: '$vuetify.icons.acuIcon', acu: true, auricular: true},
        {id: 2, name: this.$gettext("Moxa"), icon: '$vuetify.icons.acuTechnic4', acu: true, auricular: true},
        {id: 3, name: this.$gettext("Bleeding"), icon: '$vuetify.icons.acuTechnic1', acu: true, auricular: true},
        {id: 4, name: this.$gettext("Cupping"), icon: '$vuetify.icons.acuTechnic3', acu: true, auricular: false},
        {id: 5, name: this.$gettext("Electro"), icon: '$vuetify.icons.acuTechnic2', acu: true, auricular: true},
        {id: 6, name: this.$gettext("Magnetic Sphere"), icon: 'mdi-circle-slice-8', acu: false, auricular: true},
        {id: 7, name: this.$gettext("Seeds"), icon: 'mdi-circle-medium', acu: false, auricular: true},
        {id: 8, name: this.$gettext("ASP"), icon: 'mdi-arrow-down-bold', acu: false, auricular: true},
        {id: 9, name: this.$gettext("TDP"), icon: 'mdi-white-balance-sunny', acu: true, auricular: false}
      ]
			//return this.$store.getters.acuTechnics(this.point.auricular);
			if(this.point.auricular) return technics.filter(t => t.auricular);
      else return technics.filter(t => t.acu);
		},
		sideLetter() {
			if (this.point.side === "left") return this.$pgettext("abrev", "Left");
			else if (this.point.side === "right") return this.$pgettext("abrev", "Right");
			else return this.$gettext("Cent.");
		}
	},
	methods: {
		removePoint() {
			this.deleting = true;
			this.$emit("remove-point", this.point);
		},
		showInfo() {
			this.loading = true;
			this.showPointInfo = true;
			this.getInfo();
		},
		getInfo() {
			console.log("GET INFO");
			this.$store.dispatch("GET_POINT_INFO", {id: this.point.id, form: false}).then((point) => {
				this.point.groups = point.groups;
				this.loading = false;
			});
		},
		getTechnicName(id) {
			for(let i = 0; i < this.technics.length; i++) {
				if(this.technics[i].id == id) return this.technics[i].name;
			}
		},
		getTechnicIcon(id) {
			for(let i = 0; i < this.technics.length; i++) {
				if(this.technics[i].id == id) return this.technics[i].icon;
			}
		},
		saveTechnics() {
			let appointment = this.$route.params.aid;
			if(this.graphic) appointment = null;
			let data = {
				appointment: appointment,
				op: "edit_point_technics",
				point_id: this.point.id,
				technics: this.point.technics
			}
			if(appointment) {
				this.savingEditTechnics = true;
				this.$store.dispatch("EDIT_POINT_TECHNICS", data).then(() => {
					this.showEditTechnics = false;
					this.savingEditTechnics = false;
					this.showPointInfo = false;
				});
			} else {
				this.showEditTechnics = false;
				this.showPointInfo = false;
			}
		}
	}
};
</script>